import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from '@mui/material';
import { useTranslation } from '../../hooks/useTranslation';

function DeleteConfirmationDialog({ open, onClose, onConfirm, loading }) {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{t('bookDetail.delete')}</DialogTitle>
      <DialogContent>
        <Typography>
          {t('bookDetail.deleteConfirm')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          {t('bookDetail.deleteConfirmDescription')}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          {t('common.cancel')}
        </Button>
        <Button
          onClick={onConfirm}
          color="error"
          variant="contained"
          disabled={loading}
        >
          {loading ? 'Deleting...' : t('common.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteConfirmationDialog; 